import React, {ReactNode} from "react";
import DomHelper from "../../helper/DomHelper";
import Translate from "../../translation/Translate";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class DepartmentalStamp extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let id: string = "gradient-" + DomHelper.generateUUID();

		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox={"0 0 300 52"}>
				<g style={{
					opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
					transformOrigin: "50% 50%"
				}}>
					<defs>
						<linearGradient id={id} x1={0} x2="100%" y1={0} y2={0}>
							<stop offset={0} style={{stopOpacity: 1, stopColor: "#E7F0F5"}}/>
							<stop offset="100%" style={{stopOpacity: 1, stopColor: "#CCD6E4"}}/>
						</linearGradient>
					</defs>
					{FunctionHelper.exists(this.props.onMoveStart) &&
						<rect x={1} y={1} rx={5} ry={5} width={298} height={50} className="movearea"
                              onClick={this.props.onClick} onContextMenu={this.props.onContextMenu}
							  onPointerDown={this.props.onMoveStart}/>
					}
					<rect x={1} y={1} rx={5} ry={5} width={298} height={50} style={{
						fill: "#E7F0F5",
						strokeWidth: 1,
						stroke: "#244C7A"
					}}/>
					<text x={"50%"} y={"50%"} dominantBaseline={"central"} style={{
						fontFamily: "sans-serif",
						fontWeight: "bold",
						fontStyle: "italic",
						textAnchor: "middle",
						textTransform: "uppercase",
						fill: "#244C7A",
						fontSize: "28px"
					}}>
						<Translate {...this.props} data="annotation.stamp_types.departmental"
								   namespace="sidebar"/>
					</text>
				</g>
			</svg>
		);
	}
}